export default {
  employees: [],
  employeeIds: [],
  balanceIds: [],
  startDate: '',
  endDate: '',
  periodicity: ''
};
